import * as React from 'react';
import { Native } from '../../../shared/types/ast';
import { escape, isNonEmptyArray } from '../../utils/component/helpers';

type Props = {
    native: Native;
    className?: string;
    style?: React.CSSProperties;
    width?: number | string;
    height?: number | string;
};

function getImageUrl(native: Native) {
    let imageUrl;
    if (native.image && native.image.url) {
        // v3
        imageUrl = native.image.url;
    } else if (isNonEmptyArray(native.mainMedia) && native.mainMedia[0].url) {
        // v2
        imageUrl = native.mainMedia[0].url;
    } else {
        return;
    }
    return escape(imageUrl);
}

const BackgroundMedia = ({ native, className, style }: Props) => (
    <div
        className={className}
        style={{
            ...style,
            backgroundImage: `url("${getImageUrl(native) || ''}")`,
        }}
    />
);

export default BackgroundMedia;
